const clear = [
    '12-16-05_1630.JPG',
    '12-23-05_1630.JPG',
    'IMG_0074.JPG',
    'IMG_0082.JPG',
    'IMG_0096.JPG',
    'IMG_0097.JPG',
    'IMG_0136.JPG',
    'IMG_0137.JPG',
    'IMG_0142.JPG',
    'IMG_0275.JPG',
    'IMG_0319.JPG',
    'IMG_0379.JPG',
    'IMG_0396.JPG',
    'IMG_0397.JPG',
    'IMG_0398.JPG',
    'IMG_0558.JPG',
    'IMG_0614.JPG',
    'IMG_0629.JPG',
    'IMG_0636.JPG',
    'IMG_0714.JPG',
    'IMG_0718.JPG',
    'IMG_0724.JPG',
    'IMG_0766.JPG',
    'IMG_0799.JPG',
    'IMG_0808.JPG',
    'IMG_0812.JPG',
    'IMG_0816.JPG',
    'IMG_0863.JPG',
    'IMG_0867.JPG',
    'IMG_0903.JPG',
    'IMG_0904.JPG',
    'IMG_0905.JPG',
    'IMG_0908.JPG',
    'IMG_0915.JPG',
    'IMG_0933.JPG',
    'IMG_0939.JPG',
    'IMG_0946.JPG',
    'IMG_0960.JPG',
    'IMG_0963.JPG',
    'IMG_0965.JPG',
    'IMG_1070.JPG',
    'IMG_1086.JPG',
    'IMG_1174.JPG',
    'IMG_1176.JPG',
    'IMG_1264.JPG',
    'IMG_1351.JPG',
    'IMG_1365.JPG',
    'IMG_1453.JPG',
    'IMG_1467.JPG',
    'IMG_1518.JPG',
    'IMG_1566.JPG',
    'IMG_1577.JPG',
    'IMG_1583.JPG',
    'IMG_1591.JPG',
    'IMG_1602.JPG',
    'IMG_1647.JPG',
    'IMG_1740.JPG',
    'IMG_1748.JPG',
    'IMG_1752.JPG',
    'IMG_1769.JPG',
    'IMG_1780.JPG',
    'IMG_1784.JPG',
    'IMG_1806.JPG',
    'IMG_1816.JPG',
    'IMG_1856.JPG',
    'IMG_1915.JPG',
    'IMG_1918.JPG',
    'IMG_1926.JPG',
    'IMG_1927.JPG',
    'IMG_1956.JPG',
    'IMG_2006.JPG',
    'IMG_2014.JPG',
    'IMG_2029.JPG',
    'IMG_2038.JPG',
    'IMG_2268.JPG',
    'IMG_2273.JPG',
    'IMG_2400.JPG',
    'IMG_2429.JPG',
    'IMG_2437.JPG',
    'IMG_2452.JPG',
    'IMG_2467.JPG',
    'IMG_2514.JPG',
    'IMG_2577.JPG',
    'IMG_2594.JPG',
    'IMG_2611.JPG',
    'IMG_2612.JPG',
    'IMG_2613.JPG',
    'IMG_2619.JPG',
    'IMG_2809.JPG',
    'IMG_2814.JPG',
    'IMG_2816.JPG',
    'IMG_2822.JPG',
    'IMG_2824.JPG',
    'IMG_3015.JPG',
    'IMG_3025.JPG',
    'IMG_3031.JPG',
    'IMG_3043.JPG',
    'IMG_3050.JPG',
    'IMG_3084.JPG',
    'IMG_3086.JPG',
    'IMG_3105.JPG',
    'IMG_3120.JPG',
    'IMG_3245.JPG',
    'IMG_3270.JPG',
    'IMG_3315.JPG',
    'IMG_3335.JPG',
    'IMG_3336.JPG',
    'IMG_3373.JPG',
    'IMG_3409.JPG',
    'IMG_3480.JPG',
    'IMG_3497.JPG',
    'IMG_3553.JPG',
    'IMG_3579.JPG',
    'IMG_3665.JPG',
    'IMG_3752.JPG',
    'IMG_3833.JPG',
    'IMG_3836.JPG',
    'IMG_3878.JPG',
    'IMG_3952.JPG',
    'IMG_3967.JPG',
    'IMG_4015.JPG',
    'IMG_4020.JPG',
    'IMG_4022.JPG',
    'IMG_4222.JPG',
    'IMG_4233.JPG',
    'REBELXS_IMG_0312.JPG',
    'REBELXS_IMG_0357.JPG',
    'REBELXS_IMG_0375.JPG',
    'REBELXS_IMG_0393.JPG',
    'REBELXS_IMG_0476.JPG',
    'REBELXS_IMG_0762.JPG',
    'REBELXS_IMG_0783.JPG',
    'REBELXS_IMG_0786.JPG',
    'REBELXS_IMG_0875.JPG',
    'REBELXS_IMG_0919.JPG',
    'REBELXS_IMG_1009.JPG',
    'REBELXS_IMG_1016.JPG',
    'REBELXS_IMG_1076.JPG',
    'REBELXS_IMG_1268.JPG',
    'REBELXS_IMG_1269.JPG',
    'REBELXS_IMG_1661.JPG',
    'REBELXS_IMG_1704.JPG',
    'REBELXS_IMG_1798.JPG',
    'REBELXS_IMG_1806.JPG',
    'REBELXS_IMG_1827.JPG',
    'REBELXS_IMG_1855.JPG',
    'REBELXS_IMG_1948.JPG',
    'REBELXS_IMG_2105.JPG',
    'REBELXS_IMG_2134.JPG',
    'REBELXS_IMG_2149.JPG',
    'REBELXS_IMG_2156.JPG',
    'REBELXS_IMG_2234.JPG',
    'REBELXS_IMG_2240.JPG',
    'REBELXS_IMG_2356.JPG',
    'REBELXS_IMG_2420.JPG',
    'REBELXS_IMG_2580.JPG',
    'REBELXS_IMG_2629.JPG',
    'REBELXS_IMG_2631.JPG',
    'REBELXS_IMG_2822.JPG',
    'REBELXS_IMG_2976.JPG',
    'REBELXS_IMG_3013.JPG',
    'REBELXS_IMG_3083.JPG',
    'REBELXS_IMG_3114.JPG',
    'REBELXS_IMG_3180.JPG',
    'REBELXS_IMG_3420.JPG',
    'REBELXS_IMG_3437.JPG',
    'REBELXS_IMG_3524.JPG',
    'REBELXS_IMG_3525.JPG',
    'STC_3239.JPG',
    'IPHONE2G_IMG_0001.JPG',
    'IPHONE2G_IMG_0003.JPG',
    'IPHONE2G_IMG_0065.JPG',
    'IPHONE2G_IMG_0124.JPG',
    'IPHONE2G_IMG_0125.JPG',
    'IPHONE2G_IMG_0234.JPG',
    'IPHONE2G_IMG_0239.JPG',
    'IPHONE2G_IMG_0242.JPG',
    'IPHONE2G_IMG_0247.JPG',
    'IPHONE2G_IMG_0248.JPG',
    'IPHONE2G_IMG_0274.JPG',
    'IPHONE2G_IMG_0275.JPG',
    'IPHONE2G_IMG_0454.JPG'
];

export default clear;